var config = require("app/config"),
    get    = require("object-path").get;

/**
 * @param   {string}   url      The image url
 * @param   {int}      width    The output image width
 * @param   {int}      height   The output image height
 * @param   {string=}  format   The output image format
 * @param   {int=}     quality  The output image quality
 * @return  {string}   The url to the optimized image
 */
module.exports = function(url, width, height, format, quality) {
    var optimizedImageUrl;

    optimizedImageUrl = new URL(url);
    optimizedImageUrl.searchParams.append("width", width);
    optimizedImageUrl.searchParams.append("height", height);

    // Optional image format filter
    format = format || "";
    format = format.toLowerCase();
    format = ["jpg", "png"].includes(format) ? format : "jpg";
    optimizedImageUrl.searchParams.append("format", format);

    // Optional quality filter
    if (quality && format !== "png") {
        optimizedImageUrl.searchParams.append("quality", get(config, "imageOptimizer.quality", 85));
    }

    return optimizedImageUrl.toString();
};
